var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.isAdmin)?[_c('Dashboard')]:(_vm.isStoreKeeper)?[_c('DashboardProducer')]:(_vm.isAffiliate)?[_c('DashboardAffiliate')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }